import { FC } from "react";

import { FullWidthVStack } from "@components/common";
import responsiveStyle from "@lib/theme/responsiveStyle";

import { OrderStep } from "../../constants";
import useCommonOrderSideEffects from "../../hooks/common/useCommonOrderSideEffects";
import useSummarySideEffects from "../../hooks/summary/useSummarySideEffects";
import OrderFooter from "../common/OrderFooter";
import OrderForm from "../common/OrderForm";
import OrderPrice from "../common/OrderPrice";
import Agreements from "./Agreements";
import OrderInfo from "./OrderInfo";
import PaymentMethods from "./PaymentMethods";
import SaveForLaterAction from "./SaveForLaterAction";
import Signature from "./Signature";

const Summary: FC = () => {
  useCommonOrderSideEffects(OrderStep.Summary);
  useSummarySideEffects();

  return (
    <OrderForm style={{ height: "100%" }}>
      <FullWidthVStack spacing={responsiveStyle({ mobile: "1.625rem", desktop: "1rem" })} height="100%">
        <FullWidthVStack spacing={responsiveStyle({ mobile: "1.625rem", desktop: "1rem" })}>
          <FullWidthVStack spacing="0.5rem">
            <OrderInfo />
          </FullWidthVStack>
          <OrderPrice />
          <Agreements />
          <PaymentMethods />
          <Signature />
          <SaveForLaterAction />
        </FullWidthVStack>
        <OrderFooter currentStep={OrderStep.Summary} />
      </FullWidthVStack>
    </OrderForm>
  );
};
export default Summary;
